import React, { useEffect, useState } from "react";
import {
    Box,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Text,
    Spinner,
    Flex,
    Tag,
    Center,
} from "@chakra-ui/react";
import { fetchWrapper } from "../../helpers/fetch-wrapper";
import moment from "moment";
import Header from "../../components/Header";
import BoxWrapper from "../../components/BoxWrapper/BoxWrapper";
import Pagination from "react-js-pagination";

const DemoRequests = () => {
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        per_page: 10,
        current_page: 1,
        pages: 1,
    });
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);

    const loadList = async (pageNum = 1) => {
        try {
            setLoading(true);
            const url = `https://web-api.xnotify.com/demo-request/list?page=${pageNum}`;
            const data = await fetchWrapper.get(url);

            if (data?.success) {
                setList(data.data.requests);
                setPagination(data.data.pagination);
            }
        } catch (error) {
            console.error("Error fetching demo requests:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadList(page);
    }, [page]);

    return (
        <>
            <Header />
            <BoxWrapper>
                {/* Header Section */}
                <Flex justify="space-between" align="center" mb={4}>
                    <Text fontSize="xl" fontWeight="bold" color="gray.700">
                        Demo Requests
                    </Text>
                    <Text fontSize="sm" color="gray.500">
                        Total: {pagination?.total || 0}
                    </Text>
                </Flex>

                {/* Table or Loader */}
                {loading ? (
                    <Center py={20}>
                        <Spinner size="xl" />
                    </Center>
                ) : (
                    <Table variant="simple" colorScheme="gray" size="md">
                        <Thead>
                            <Tr>
                                <Th>ID</Th>
                                <Th>Full Name</Th>
                                <Th>Company</Th>
                                <Th>Email</Th>
                                <Th>Channels</Th>
                                <Th>Volume</Th>
                                <Th>Industry</Th>
                                <Th>Status</Th>
                                <Th>Created At</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {list.length > 0 ? (
                                list.map((req, index) => (
                                    <Tr
                                        key={req.id}
                                        _hover={{ bg: "gray.50" }}
                                        bg={index % 2 === 0 ? "white" : "gray.50"}
                                    >
                                        <Td>{req.id}</Td>
                                        <Td>{req.full_name}</Td>
                                        <Td>{req.company_name}</Td>
                                        <Td>{req.business_email}</Td>
                                        <Td>
                                            <Text fontSize="sm" color="gray.700">
                                                {req.channels_text}
                                            </Text>
                                        </Td>
                                        <Td>{req.monthly_message_volume}</Td>
                                        <Td>{req.industry}</Td>
                                        <Td>
                                            <Tag
                                                colorScheme={
                                                    req.status === "pending"
                                                        ? "yellow"
                                                        : req.status === "approved"
                                                        ? "green"
                                                        : "red"
                                                }
                                                px={3}
                                                py={1}
                                                borderRadius="md"
                                            >
                                                {req.status}
                                            </Tag>
                                        </Td>
                                        <Td>{moment(req.created_at).format("DD MMM YYYY")}</Td>
                                    </Tr>
                                ))
                            ) : (
                                <Tr>
                                    <Td colSpan={9} textAlign="center" py={10}>
                                        No demo requests found.
                                    </Td>
                                </Tr>
                            )}
                        </Tbody>
                    </Table>
                )}

                {/* Pagination */}
                {!loading && pagination.pages > 1 && (
                    <Flex justify="center" align="center" mt={6}>
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={pagination.per_page}
                            totalItemsCount={pagination.total}
                            pageRangeDisplayed={5}
                            onChange={(pageNumber) => setPage(pageNumber)}
                            itemClass="page-item"
                            linkClass="page-link"
                            innerClass="pagination"
                        />
                    </Flex>
                )}
            </BoxWrapper>
        </>
    );
};

export default DemoRequests;
